// Local Deps
import { makeGraphQLRequest } from '../../utils/requestUtils';

export default async function addToTooling({
  niin,
  partNum,
  ownerCage,
  description,
  comments,
  cage,
  toolingRef,
  designAlloy,
  accessLevel,
  category,
  modifiedBy,
}) {
  // Format Mutation
  const query = `mutation addTooling(
    $toolInput: NewToolInput
  ) {
     addTooling(tool:$toolInput)
      {
        id
        status
        msg
      }
    }`;

  // Variables
  const variables = {
    toolInput: {
      niin,
      partNum,
      ownerCage,
      description,
      comments,
      cage,
      toolingRef,
      designAlloy,
      accessLevel,
      category,
      modifiedBy,
      // ownerName,
      // revisionNumber,
    },
  };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}




// export async function getCageCode(id) {
//   const query = `query requestOrganizationById(
//     $id: ID
//   ) {
//       organization(id: $id) {
//         cageCode
//       }
//     }`;

//   const variables = { id };
//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });

//   return response;
// }

// export async function getOrgByID(id) {
//   // Format Query
//   const query = `query organization(
//     $id: ID
//   ) {
//     organization(id: $id) {
//       name
   
//       cageCode
     
//       }
//     }`;

//   // Variables
//   const variables = { id };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response.organization;
// }



// WEBPACK FOOTER //
// ./src/components/AddTooling/graphql.js